import React from "react";

const ErrorMsg = () => {
  return (
    <div className="error">
      Error Retrieving Data
      <br /> Please Reload the Page
    </div>
  );
};

export default ErrorMsg;
